module.exports = __webpack_public_path__ + "media/vendors/vendors-sm-43438f32.png";